import { AfterViewInit, Component, ViewChild } from '@angular/core';
import {
  AppTableComponent, RequestModel, TranslationManager, Auth, RequestsService, SearchModel, SearchResultModel,
  MessagesComponent, RequestStatusModel, RequestStatusUniqueIdentifier, CheckSendOpnForConfirmationModel, RequestMessageSendModel, RequestSendModel
} from 'src/common';

@Component({
  selector: 'requests',
  templateUrl: 'requests.component.html'
})

export class RequestsComponent implements AfterViewInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  requestItemsIds: number[] = [];
  checkSendOpnForConfirmationModel: CheckSendOpnForConfirmationModel[];
  requestMessageSendModel: RequestMessageSendModel;
  requestSendModel: RequestSendModel;
  requestId: number;
   showDeleteModal: boolean = false;
  showSendOpnConfirmationModal: boolean;
  showRejectionOpnModal: boolean;
  showRejectionOpnModalMsg: boolean;

  message: string;
  translationManager = TranslationManager;
  auth = Auth;
  requestStatusUniqueIdentifier = RequestStatusUniqueIdentifier;

  requestStatuses: any[] = [];
  items: RequestModel[] = [];

  constructor(private requestsService: RequestsService) { }
  ngOnInit(): void {
    this.showDeleteModal = false;
    this.showSendOpnConfirmationModal = false;
    this.showRejectionOpnModal = false;
    this.showRejectionOpnModalMsg = false;
  }

  ngAfterViewInit(): void {

    if (this.auth.isAuthorized('35988B5B-7B53-4995-B8E8-1032966DCDE9')) {
      this.appTable.onSearch = this.doSearch.bind(this);
    }
    else if (this.auth.isAuthorized('F534BDAA-6F9A-4644-A037-34C5AC63F65D')) {
      this.appTable.onSearch = this.doSearchTeamMembers.bind(this);
    }
    this.appTable.search();

    this.requestsService.getRequestStatusesFilter().then((statuses: RequestStatusModel[]) => {
      statuses.forEach(s => {
        this.requestStatuses.push({ label: s.label, value: s.label });
      });
    });
  }

  doSearch(search: SearchModel) {
    this.requestsService.search(search).then((result: SearchResultModel<RequestModel>) => {
      
      this.items = result.items;
      this.appTable.setTotalCount(result.totalCount);
      this.mapRequestItemsId();
    });
  }

  doSearchTeamMembers(search: SearchModel) {
    this.requestsService.searchTeamMembers(search).then((result: SearchResultModel<RequestModel>) => {
      this.items = result.items;
      this.mapRequestItemsId();
    });
  }

  private mapRequestItemsId() {

    this.items.forEach((i) => {
      this.requestItemsIds.push(Number(i.id));
    });

    this.requestsService.searchCheckSendOpnForConfirmationView(this.requestItemsIds).then((result: CheckSendOpnForConfirmationModel[]) => {
      this.checkSendOpnForConfirmationModel = result;
    });

  }

  chooseModal(id: number, modal: string, state: boolean) {
    this.requestId = id;
    if (modal == 'delete') {
      this.showDeleteModal = state;
    }
    else if (modal == 'onApproval') {
      this.showSendOpnConfirmationModal = state;
    }
    else if (modal == 'rejected') {
      this.showRejectionOpnModal = state;
    } else if (modal == 'rejectedMsg') {
      this.showRejectionOpnModalMsg = state;
    }
  }

  delete() {
    if (this.requestId > 0) {
      this.requestsService.delete(this.requestId).then(() => {
        this.chooseModal(0, 'delete', false);
        this.appTable.search();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }

  showButtonSendOpnForConfirmation(id: number) {
    if (id != null && this.checkSendOpnForConfirmationModel != null) {
      let check = this.checkSendOpnForConfirmationModel.find(q => q.id == id);
      if (check != null) {
        if (check.isTrue === true) {
          return true;
        }

      }
    }
    return false;
  }

  changeRequestOpnStatusApproved() {
    if (this.requestId > 0) {
      this.requestSendModel = new RequestSendModel();
      this.requestSendModel.id = this.requestId;
      this.requestsService.changeRequestOpnStatusApproved(this.requestSendModel).then(() => {
        this.chooseModal(0, 'onApproval', false);
        this.appTable.search();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Статус захтева успешно промењен')]);
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }

  requestRejectMessage() {
    let id = this.requestId;
    this.chooseModal(0, 'rejected', false);
    this.chooseModal(id, 'rejectedMsg', true);
  }

  RejectionOfOPNModal() {
    if (this.requestId > 0) {
      this.requestMessageSendModel = new RequestMessageSendModel();
      this.requestMessageSendModel.id = this.requestId;
      this.requestMessageSendModel.message = this.message;

      this.requestsService.changeRequestOpnStatusRejected(this.requestMessageSendModel).then(() => {
        this.chooseModal(0, 'rejectedMsg', false);
        this.appTable.search();
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Статус захтева успешно промењен')]);
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });
    }
  }
}
